export default "__VITE_ASSET__DJRNL1U8__"